/* ==========================================================================
   SMOON — Landing Boxer Menstruel Ado
   Carrousels, accordéons, sélecteurs de variante, ajout panier AJAX,
   guide des tailles, lightbox images et apparitions au scroll.
   Vanilla, sans dépendance, idempotent (sûr avec l'éditeur de thème).
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.ba[data-ba-root]';

  /* ---------------------------------------------------------------- utils */
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var f = window.Shopify && window.Shopify.money_format;
    var v = (cents / 100).toFixed(2).replace('.', ',');
    if (f && f.indexOf('{{') > -1) {
      return f.replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return v + ' €';
  }

  /* ------------------------------------------------------------ carrousels
     Piste en scroll-snap : pas de JS pour le défilement lui-même (natif,
     donc fluide et accessible au swipe), le JS ne gère que flèches + points. */
  function initSlider(vp) {
    if (vp.dataset.baSlider) return;
    vp.dataset.baSlider = '1';

    /* la piste est l'élément lui-même s'il la porte — sinon on descend, mais
       jamais dans un slider imbriqué (un rail de cartes n'est pas la galerie
       d'une de ses cartes) */
    var track = vp.matches('[data-ba-track]') ? vp : null;
    if (!track) {
      var cands = vp.querySelectorAll('[data-ba-track]');
      for (var c = 0; c < cands.length; c++) {
        var owner = cands[c].closest('[data-ba-slider]');
        if (!owner || owner === vp) { track = cands[c]; break; }
      }
    }
    if (!track) return;
    /* l'élément qui scrolle est celui qui porte l'overflow : la piste, ou son
       conteneur si la piste n'est pas elle-même scrollable */
    function scroller() {
      return track.scrollWidth > track.clientWidth + 1 ? track : vp;
    }
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 1) return;

    /* les contrôles peuvent vivre dans la piste, à côté d'elle, ou plus haut
       dans la section (flèches d'avis, points sous un rail) */
    function ctrl(sel) {
      var scopes = [vp, vp.parentElement, vp.parentElement && vp.parentElement.parentElement, vp.closest('section')];
      for (var i = 0; i < scopes.length; i++) {
        if (!scopes[i]) continue;
        var els = scopes[i].querySelectorAll(sel);
        for (var j = 0; j < els.length; j++) {
          /* ignorer les contrôles qui appartiennent à un slider imbriqué
             (un rail de cartes ne doit pas piloter les points d'une carte) */
          var owner = els[j].closest('[data-ba-slider]');
          if (owner && owner !== vp) continue;
          return els[j];
        }
      }
      return null;
    }
    var dotsBox = ctrl('[data-ba-dots]');
    var thumbsBox = ctrl('[data-ba-thumbs]');
    var prev = ctrl('[data-ba-prev]');
    var next = ctrl('[data-ba-next]');
    var dots = dotsBox ? Array.prototype.slice.call(dotsBox.children) : [];
    var thumbs = thumbsBox ? Array.prototype.slice.call(thumbsBox.children) : [];
    var index = 0;

    function step() {
      return slides.length > 1 ? Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft) : 1;
    }

    function current() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(scroller().scrollLeft / step())));
    }

    function paint(i) {
      index = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        if (k === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      var sc = scroller();
      var atStart = sc.scrollLeft <= 2;
      var atEnd = sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2;
      var noScroll = sc.scrollWidth <= sc.clientWidth + 2;
      if (prev) prev.disabled = noScroll || atStart;
      if (next) next.disabled = noScroll || atEnd;
    }

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      scroller().scrollTo({ left: i * step(), behavior: smooth === false ? 'auto' : 'smooth' });
      paint(i);
    }

    vp.baGoTo = goTo;

    var raf;
    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { paint(current()); });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    if (vp !== track) vp.addEventListener('scroll', onScroll, { passive: true });

    function page(dir) {
      var sc = scroller();
      var perView = Math.max(1, Math.round(sc.clientWidth / step()));
      goTo(current() + dir * perView);
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });

    paint(0);
    window.addEventListener('resize', function () { paint(current()); }, { passive: true });
  }

  /* ------------------------------------------------------------- accordéon */
  function initAccordion(root) {
    $$('[data-ba-feat]', root).forEach(function (item) {
      if (item.dataset.baInit) return;
      item.dataset.baInit = '1';
      var head = item.querySelector('[data-ba-feat-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --------------------------------------------------- variantes + panier */
  function initProductForm(scope) {
    if (scope.dataset.baForm) return;
    scope.dataset.baForm = '1';

    var dataEl = scope.querySelector('[data-ba-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = scope.querySelector('[data-ba-variant]');
    var input = scope.querySelector('[data-ba-id]');
    var btn = scope.querySelector('[data-ba-add]');
    var lbl = btn ? btn.querySelector('[data-ba-lbl]') : null;
    var priceEl = scope.querySelector('[data-ba-price]');
    var wasEl = scope.querySelector('[data-ba-was]');

    /* galerie associée : dans la carte elle-même, ou dans la même section
       (le produit principal a sa galerie dans une colonne voisine) */
    var gallery = scope.querySelector('[data-ba-slider]');
    if (!gallery) {
      var host = scope.closest('section') || scope.parentElement;
      gallery = host ? host.querySelector('[data-ba-slider]') : null;
    }

    function variantById(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    var booted = false;

    function sync() {
      var v = variantById(select ? select.value : (input && input.value));
      if (!v) return;
      if (input) input.value = v.id;

      /* la galerie suit la variante choisie (photo portée de la bonne couleur) */
      if (booted && gallery && gallery.baGoTo && data.leadIdx) {
        var idx = data.leadIdx[String(v.id)];
        if (typeof idx === 'number') gallery.baGoTo(idx);
      }
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare > v.price) { wasEl.textContent = money(v.compare); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (btn) {
        btn.disabled = !v.available;
        if (lbl) {
          var t = v.available ? (data.labelAdd || '') : (data.labelOut || '');
          if (v.available && data.labelPrice) t = data.labelPrice.replace('[prix]', money(v.price));
          lbl.textContent = t;
        }
      }
    }

    if (select) select.addEventListener('change', sync);
    sync();
    booted = true;

    /* ajout panier AJAX -> ouvre le tiroir natif du thème */
    var form = scope.querySelector('[data-ba-cart-form]');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-load')) return;
      btn.classList.add('is-load');

      var body = new FormData(form);
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.location.href = form.action; return; }
          if (drawer) {
            if (drawer.classList && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (drawer.renderContents) drawer.renderContents(res);
            if (drawer.open) drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          document.dispatchEvent(new CustomEvent('ba:added', { detail: res }));
        })
        .catch(function () { window.location.href = form.action; })
        .finally(function () { btn.classList.remove('is-load'); });
    });
  }

  /* ------------------------------------------------- guide des tailles */
  function initGuide(root) {
    var panel = root.parentElement ? root.parentElement.querySelector('.ba-sg') : null;
    if (!panel) panel = document.querySelector('.ba-sg');
    if (!panel) return;

    var lastOpener = null;

    function open(opener) {
      lastOpener = opener || null;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = panel.querySelector('.ba-sg__close');
      if (close) close.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      panel.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastOpener) lastOpener.focus();
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    panel.__baClose = close;

    $$('[data-ba-guide]', root).forEach(function (link) {
      if (link.dataset.baInit) return;
      link.dataset.baInit = '1';
      link.addEventListener('click', function (e) { e.preventDefault(); open(link); });
    });

    if (!panel.dataset.baInit) {
      panel.dataset.baInit = '1';
      $$('[data-ba-sg-close]', panel).forEach(function (el) {
        el.addEventListener('click', close);
      });
    }
  }

  /* ------------------------------------------------------------- lightbox
     Ouvre l'image cliquée en grand. Fermeture : croix, clic sur le fond,
     ou Échap. Navigation au clavier et par flèches. */
  function initLightbox(root) {
    var lb = document.querySelector('.ba-lb');
    if (!lb) return;

    var imgEl = lb.querySelector('[data-ba-lb-img]');
    var stage = lb.querySelector('[data-ba-lb-stage]');
    var countEl = lb.querySelector('[data-ba-lb-count]');
    var prevBtn = lb.querySelector('[data-ba-lb-prev]');
    var nextBtn = lb.querySelector('[data-ba-lb-next]');
    var group = [];
    var pos = 0;
    var opener = null;

    function render() {
      var src = group[pos];
      if (!src) return;
      imgEl.src = src.full;
      imgEl.alt = src.alt || '';
      if (src.w && src.h) { imgEl.width = src.w; imgEl.height = src.h; }
      var multi = group.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      countEl.textContent = multi ? (pos + 1) + ' / ' + group.length : '';
    }

    function open(list, index, from) {
      group = list;
      pos = index;
      opener = from || null;
      render();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      lb.querySelector('.ba-lb__close').focus();
    }

    function close() {
      lb.hidden = true;
      imgEl.removeAttribute('src');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (opener) opener.focus();
    }

    function move(d) {
      if (group.length < 2) return;
      pos = (pos + d + group.length) % group.length;
      render();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') move(-1);
      else if (e.key === 'ArrowRight') move(1);
    }

    if (!lb.dataset.baInit) {
      lb.dataset.baInit = '1';
      lb.querySelector('[data-ba-lb-close]').addEventListener('click', close);
      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); move(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); move(1); });
      /* clic sur le fond (tout sauf l'image elle-même) = fermeture */
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.ba-lb__nav, .ba-lb__close')) return;
        if (e.target === imgEl) return;
        close();
      });
      /* swipe horizontal sur mobile */
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) move(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }

    /* chaque piste d'images devient un groupe navigable */
    $$('[data-ba-track]', root).forEach(function (track) {
      var imgs = $$('img', track);
      if (!imgs.length) return;
      imgs.forEach(function (img) {
        if (img.dataset.baLbInit) return;
        img.dataset.baLbInit = '1';
        img.addEventListener('click', function () {
          var list = $$('img', track).map(function (i) {
            return {
              full: (i.currentSrc || i.src).replace(/([?&])width=\d+/, '$1width=1600'),
              alt: i.alt,
              w: i.naturalWidth || i.width,
              h: i.naturalHeight || i.height
            };
          });
          open(list, $$('img', track).indexOf(img), img);
        });
      });
    });
  }

  /* -------------------------------------------------- ancres de scroll interne */
  function initAnchors(root) {
    $$('[data-ba-scroll]', root).forEach(function (a) {
      if (a.dataset.baInit) return;
      a.dataset.baInit = '1';
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.dataset.baScroll);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------ apparitions */
  function initReveal(root) {
    var els = $$('.ba-anim', root).filter(function (el) { return !el.dataset.baSeen; });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.dataset.baSeen = '1'; io.observe(el); });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    if (!root) return;
    $$('[data-ba-slider]', root).forEach(initSlider);
    $$('[data-ba-product]', root).forEach(initProductForm);
    initAccordion(root);
    initGuide(root);
    initLightbox(root);
    initAnchors(root);
    initReveal(root);
  }

  function bootAll() { $$(SEL).forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* éditeur de thème : la section est réinjectée à chaque modification */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector(SEL) || (e.target.matches && e.target.matches(SEL) ? e.target : null);
    boot(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var vp = e.target.closest('[data-ba-slider]');
    if (vp && vp.baGoTo) {
      var slides = Array.prototype.slice.call(vp.querySelector('[data-ba-track]').children);
      var i = slides.indexOf(e.target.closest('[data-ba-slide]'));
      if (i > -1) vp.baGoTo(i);
    }
  });
})();
